import _toConsumableArray from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { isArray } from 'vega-util';
import { isBinned, isBinning, isBinParams } from '../../bin';
import { COLOR, FILL, isXorY, isXorYOffset, POLAR_POSITION_SCALE_CHANNELS, POSITION_SCALE_CHANNELS, STROKE } from '../../channel';
import { getFieldDef, getFieldOrDatumDef, isFieldDef, valueExpr } from '../../channeldef';
import { isDateTime } from '../../datetime';
import { channelHasNestedOffsetScale } from '../../encoding';
import * as log from '../../log';
import { channelScalePropertyIncompatability, hasContinuousDomain, isContinuousToContinuous, isContinuousToDiscrete, ScaleType, scaleTypeSupportProperty } from '../../scale';
import * as util from '../../util';
import { contains, getFirstDefined, keys } from '../../util';
import { isSignalRef } from '../../vega.schema';
import { getBinSignalName } from '../data/bin';
import { isUnitModel } from '../model';
import { SignalRefWrapper } from '../signal';
import { mergeValuesWithExplicit, tieBreakByComparing } from '../split';
import { parseUnitScaleRange } from './range';
export function parseScaleProperty(model, property) {
  if (isUnitModel(model)) {
    parseUnitScaleProperty(model, property);
  } else {
    parseNonUnitScaleProperty(model, property);
  }
}

function parseUnitScaleProperty(model, property) {
  var localScaleComponents = model.component.scales;
  var config = model.config,
      encoding = model.encoding,
      markDef = model.markDef,
      specifiedScales = model.specifiedScales;

  var _iterator = _createForOfIteratorHelper(keys(localScaleComponents)),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var channel = _step.value;
      var specifiedScale = specifiedScales[channel];
      var localScaleCmpt = localScaleComponents[channel];
      var mergedScaleCmpt = model.getScaleComponent(channel);
      var fieldOrDatumDef = getFieldOrDatumDef(encoding[channel]);
      var specifiedValue = specifiedScale[property];
      var scaleType = mergedScaleCmpt.get('type');
      var scalePadding = mergedScaleCmpt.get('padding');
      var scalePaddingInner = mergedScaleCmpt.get('paddingInner');
      var supportedByScaleType = scaleTypeSupportProperty(scaleType, property);
      var channelIncompatability = channelScalePropertyIncompatability(channel, property);

      if (specifiedValue !== undefined) {
        // If there is a specified value, check if it is compatible with scale type and channel
        if (!supportedByScaleType) {
          log.warn(log.message.scalePropertyNotWorkWithScaleType(scaleType, property, channel));
        } else if (channelIncompatability) {
          // channel
          log.warn(channelIncompatability);
        }
      }

      if (supportedByScaleType && channelIncompatability === undefined) {
        if (specifiedValue !== undefined) {
          var timeUnit = fieldOrDatumDef['timeUnit'];
          var type = fieldOrDatumDef.type;

          switch (property) {
            // domainMax/Min to signal if the value is a datetime object
            case 'domainMax':
            case 'domainMin':
              if (isDateTime(specifiedScale[property]) || type === 'temporal' || timeUnit) {
                localScaleCmpt.set(property, {
                  signal: valueExpr(specifiedScale[property], {
                    type: type,
                    timeUnit: timeUnit
                  })
                }, true);
              } else {
                localScaleCmpt.set(property, specifiedScale[property], true);
              }

              break;

            default:
              localScaleCmpt.copyKeyFromObject(property, specifiedScale);
          }
        } else {
          var value = property in scaleRules ? scaleRules[property]({
            model: model,
            channel: channel,
            fieldOrDatumDef: fieldOrDatumDef,
            scaleType: scaleType,
            scalePadding: scalePadding,
            scalePaddingInner: scalePaddingInner,
            domain: specifiedScale.domain,
            domainMin: specifiedScale.domainMin,
            domainMax: specifiedScale.domainMax,
            markDef: markDef,
            config: config,
            hasNestedOffsetScale: channelHasNestedOffsetScale(encoding, channel)
          }) : config.scale[property];

          if (value !== undefined) {
            localScaleCmpt.set(property, value, false);
          }
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}

export var scaleRules = {
  bins: function bins(_ref) {
    var model = _ref.model,
        fieldOrDatumDef = _ref.fieldOrDatumDef;
    return isFieldDef(fieldOrDatumDef) ? _bins(model, fieldOrDatumDef) : undefined;
  },
  interpolate: function interpolate(_ref2) {
    var channel = _ref2.channel,
        fieldOrDatumDef = _ref2.fieldOrDatumDef;
    return _interpolate(channel, fieldOrDatumDef.type);
  },
  nice: function nice(_ref3) {
    var scaleType = _ref3.scaleType,
        channel = _ref3.channel,
        domain = _ref3.domain,
        domainMin = _ref3.domainMin,
        domainMax = _ref3.domainMax,
        fieldOrDatumDef = _ref3.fieldOrDatumDef;
    return _nice(scaleType, channel, domain, domainMin, domainMax, fieldOrDatumDef);
  },
  padding: function padding(_ref4) {
    var channel = _ref4.channel,
        scaleType = _ref4.scaleType,
        fieldOrDatumDef = _ref4.fieldOrDatumDef,
        markDef = _ref4.markDef,
        config = _ref4.config;
    return _padding(channel, scaleType, config.scale, fieldOrDatumDef, markDef, config.bar);
  },
  paddingInner: function paddingInner(_ref5) {
    var scalePadding = _ref5.scalePadding,
        channel = _ref5.channel,
        markDef = _ref5.markDef,
        scaleType = _ref5.scaleType,
        config = _ref5.config,
        hasNestedOffsetScale = _ref5.hasNestedOffsetScale;
    return _paddingInner(scalePadding, channel, markDef.type, scaleType, config.scale, hasNestedOffsetScale);
  },
  paddingOuter: function paddingOuter(_ref6) {
    var scalePadding = _ref6.scalePadding,
        channel = _ref6.channel,
        scaleType = _ref6.scaleType,
        scalePaddingInner = _ref6.scalePaddingInner,
        config = _ref6.config,
        hasNestedOffsetScale = _ref6.hasNestedOffsetScale;
    return _paddingOuter(scalePadding, channel, scaleType, scalePaddingInner, config.scale, hasNestedOffsetScale);
  },
  reverse: function reverse(_ref7) {
    var fieldOrDatumDef = _ref7.fieldOrDatumDef,
        scaleType = _ref7.scaleType,
        channel = _ref7.channel,
        config = _ref7.config;
    var sort = isFieldDef(fieldOrDatumDef) ? fieldOrDatumDef.sort : undefined;
    return _reverse(scaleType, sort, channel, config.scale);
  },
  zero: function zero(_ref8) {
    var channel = _ref8.channel,
        fieldOrDatumDef = _ref8.fieldOrDatumDef,
        domain = _ref8.domain,
        markDef = _ref8.markDef,
        scaleType = _ref8.scaleType;
    return _zero(channel, fieldOrDatumDef, domain, markDef, scaleType);
  }
}; // This method is here rather than in range.ts to avoid circular dependency.

export function parseScaleRange(model) {
  if (isUnitModel(model)) {
    parseUnitScaleRange(model);
  } else {
    parseNonUnitScaleProperty(model, 'range');
  }
}
export function parseNonUnitScaleProperty(model, property) {
  var localScaleComponents = model.component.scales;

  var _iterator2 = _createForOfIteratorHelper(model.children),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var child = _step2.value;

      if (property === 'range') {
        parseScaleRange(child);
      } else {
        parseScaleProperty(child, property);
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  var _iterator3 = _createForOfIteratorHelper(keys(localScaleComponents)),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var channel = _step3.value;
      var valueWithExplicit = void 0;

      var _iterator4 = _createForOfIteratorHelper(model.children),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var _child = _step4.value;
          var childComponent = _child.component.scales[channel];

          if (childComponent) {
            var childValueWithExplicit = childComponent.getWithExplicit(property);
            valueWithExplicit = mergeValuesWithExplicit(valueWithExplicit, childValueWithExplicit, property, 'scale', tieBreakByComparing(function (v1, v2) {
              switch (property) {
                case 'range':
                  // For step, prefer larger step
                  if (v1.step && v2.step) {
                    return v1.step - v2.step;
                  }

                  return 0;
                // TODO: precedence rule for other properties
              }

              return 0;
            }));
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      localScaleComponents[channel].setWithExplicit(property, valueWithExplicit);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}

function _bins(model, fieldDef) {
  var bin = fieldDef.bin;

  if (isBinning(bin)) {
    var binSignal = getBinSignalName(model, fieldDef.field, bin);
    return new SignalRefWrapper(function () {
      return model.getSignalName(binSignal);
    });
  } else if (isBinned(bin) && isBinParams(bin) && bin.step !== undefined) {
    // start and stop will be determined from the scale domain
    return {
      step: bin.step
    };
  }

  return undefined;
}

export { _bins as bins };

function _interpolate(channel, type) {
  if (contains([COLOR, FILL, STROKE], channel) && type !== 'nominal') {
    return 'hcl';
  }

  return undefined;
}

export { _interpolate as interpolate };

function _nice(scaleType, channel, specifiedDomain, domainMin, domainMax, fieldOrDatumDef) {
  var _a;

  if (((_a = getFieldDef(fieldOrDatumDef)) === null || _a === void 0 ? void 0 : _a.bin) || isArray(specifiedDomain) || domainMax != null || domainMin != null || util.contains([ScaleType.TIME, ScaleType.UTC], scaleType)) {
    return undefined;
  }

  return isXorY(channel) ? true : undefined;
}

export { _nice as nice };

function _padding(channel, scaleType, scaleConfig, fieldOrDatumDef, markDef, barConfig) {
  if (isXorY(channel)) {
    if (isContinuousToContinuous(scaleType)) {
      if (scaleConfig.continuousPadding !== undefined) {
        return scaleConfig.continuousPadding;
      }

      var type = markDef.type,
          orient = markDef.orient;

      if (type === 'bar' && !(isFieldDef(fieldOrDatumDef) && (fieldOrDatumDef.bin || fieldOrDatumDef.timeUnit))) {
        if (orient === 'vertical' && channel === 'x' || orient === 'horizontal' && channel === 'y') {
          return barConfig.continuousBandSize;
        }
      }
    }

    if (scaleType === ScaleType.POINT) {
      return scaleConfig.pointPadding;
    }
  }

  return undefined;
}

export { _padding as padding };

function _paddingInner(paddingValue, channel, mark, scaleType, scaleConfig) {
  var hasNestedOffsetScale = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (paddingValue !== undefined) {
    // If user has already manually specified "padding", no need to add default paddingInner.
    return undefined;
  }

  if (isXorY(channel)) {
    // Padding is only set for X and Y by default.
    // Basically it doesn't make sense to add padding for color and size.
    // paddingOuter would only be called if it's a band scale, just return the default for bandScale.
    var bandPaddingInner = scaleConfig.bandPaddingInner,
        barBandPaddingInner = scaleConfig.barBandPaddingInner,
        rectBandPaddingInner = scaleConfig.rectBandPaddingInner,
        bandWithNestedOffsetPaddingInner = scaleConfig.bandWithNestedOffsetPaddingInner;

    if (hasNestedOffsetScale) {
      return bandWithNestedOffsetPaddingInner;
    }

    return getFirstDefined(bandPaddingInner, mark === 'bar' ? barBandPaddingInner : rectBandPaddingInner);
  } else if (isXorYOffset(channel)) {
    if (scaleType === ScaleType.BAND) {
      return scaleConfig.offsetBandPaddingInner;
    }
  }

  return undefined;
}

export { _paddingInner as paddingInner };

function _paddingOuter(paddingValue, channel, scaleType, paddingInnerValue, scaleConfig) {
  var hasNestedOffsetScale = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

  if (paddingValue !== undefined) {
    // If user has already manually specified "padding", no need to add default paddingOuter.
    return undefined;
  }

  if (isXorY(channel)) {
    var bandPaddingOuter = scaleConfig.bandPaddingOuter,
        bandWithNestedOffsetPaddingOuter = scaleConfig.bandWithNestedOffsetPaddingOuter;

    if (hasNestedOffsetScale) {
      return bandWithNestedOffsetPaddingOuter;
    } // Padding is only set for X and Y by default.
    // Basically it doesn't make sense to add padding for color and size.


    if (scaleType === ScaleType.BAND) {
      return getFirstDefined(bandPaddingOuter,
      /* By default, paddingOuter is paddingInner / 2. The reason is that
        size (width/height) = step * (cardinality - paddingInner + 2 * paddingOuter).
        and we want the width/height to be integer by default.
        Note that step (by default) and cardinality are integers.) */
      isSignalRef(paddingInnerValue) ? {
        signal: "".concat(paddingInnerValue.signal, "/2")
      } : paddingInnerValue / 2);
    }
  } else if (isXorYOffset(channel)) {
    if (scaleType === ScaleType.POINT) {
      return 0.5; // so the point positions align with centers of band scales.
    } else if (scaleType === ScaleType.BAND) {
      return scaleConfig.offsetBandPaddingOuter;
    }
  }

  return undefined;
}

export { _paddingOuter as paddingOuter };

function _reverse(scaleType, sort, channel, scaleConfig) {
  if (channel === 'x' && scaleConfig.xReverse !== undefined) {
    if (hasContinuousDomain(scaleType) && sort === 'descending') {
      if (isSignalRef(scaleConfig.xReverse)) {
        return {
          signal: "!".concat(scaleConfig.xReverse.signal)
        };
      } else {
        return !scaleConfig.xReverse;
      }
    }

    return scaleConfig.xReverse;
  }

  if (hasContinuousDomain(scaleType) && sort === 'descending') {
    // For continuous domain scales, Vega does not support domain sort.
    // Thus, we reverse range instead if sort is descending
    return true;
  }

  return undefined;
}

export { _reverse as reverse };

function _zero(channel, fieldDef, specifiedDomain, markDef, scaleType) {
  // If users explicitly provide a domain, we should not augment zero as that will be unexpected.
  var hasCustomDomain = !!specifiedDomain && specifiedDomain !== 'unaggregated';

  if (hasCustomDomain) {
    if (hasContinuousDomain(scaleType)) {
      if (isArray(specifiedDomain)) {
        var first = specifiedDomain[0];
        var last = specifiedDomain[specifiedDomain.length - 1];

        if (first <= 0 && last >= 0) {
          // if the domain includes zero, make zero remains true
          return true;
        }
      }

      return false;
    }
  } // If there is no custom domain, return true only for the following cases:
  // 1) using quantitative field with size
  // While this can be either ratio or interval fields, our assumption is that
  // ratio are more common. However, if the scaleType is discretizing scale, we want to return
  // false so that range doesn't start at zero


  if (channel === 'size' && fieldDef.type === 'quantitative' && !isContinuousToDiscrete(scaleType)) {
    return true;
  } // 2) non-binned, quantitative x-scale or y-scale
  // (For binning, we should not include zero by default because binning are calculated without zero.)


  if (!(isFieldDef(fieldDef) && fieldDef.bin) && util.contains([].concat(_toConsumableArray(POSITION_SCALE_CHANNELS), _toConsumableArray(POLAR_POSITION_SCALE_CHANNELS)), channel)) {
    var orient = markDef.orient,
        type = markDef.type;

    if (contains(['bar', 'area', 'line', 'trail'], type)) {
      if (orient === 'horizontal' && channel === 'y' || orient === 'vertical' && channel === 'x') {
        return false;
      }
    }

    return true;
  }

  return false;
}

export { _zero as zero };